import { ICannedReply } from '../interfaces';

export const filterCannedResponses = (
  cr: ICannedReply[],
  sc: string
): ICannedReply[] => {
  if (!sc) return cr;
  return cr.filter((i) => {
    return i.shortcuts.some((s) => {
      return `#${s}`.includes(`#${sc}`);
    });
  });
};

export const filterCannedResponsesExtra = (
  cr: ICannedReply[],
  sc: string
): string[] => {
  if (!sc) return [];
  return cr
    .filter((i) => {
      return i.shortcuts.some((s) => {
        return `#${s}#`.includes(`#${sc}#`);
      });
    })
    .map((i) => i.canned_reply);
};
